module.exports = ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}"